import * as React from 'react';

import {ENTITY_TYPE_SELECT_OPTIONS} from 'shells/create-custom-field/consts';
import {CreateDecisionFieldChoices} from 'shells/create-custom-field/create-decision-field-choices';
import type {
    CustomFieldEntityOption,
    CustomFieldTypeOption,
} from 'shells/create-custom-field/types';
import {FormField} from 'shells/form/form-field';
import {Stack} from 'shells/layout/stack/stack';
import {RadioGroup} from 'shells/radio/radio-group';
import {RadioIconButton} from 'shells/radio/radio-icon-button';
import {SelectTwoLine} from 'shells/select-two-line/select-two-line';
import {TextField} from 'shells/textfield/textfield';

type Props = {
    name: string;
    setName: (name: string) => void;
    entityType: string;
    setEntityType: (entityType: string) => void;
    customFieldSelectOptions: CustomFieldTypeOption[];
    selectedCustomFieldOption: CustomFieldTypeOption;
    setSelectedCustomFieldOption: (customFieldOption: CustomFieldTypeOption) => void;
    decisionFieldChoices: string[];
    setDecisionFieldChoices: (choices: string[]) => void;
    decisionFieldAllowMultiple: boolean;
    setDecisionFieldAllowMultiple: (allowMultiple: boolean) => void;
    description: string;
    setDescription: (description: string) => void;
    isEditing: boolean;
    canUpdateMultipleChoicesSetting: boolean;
};

export function LeftSection(props: Props) {
    const [isDescriptionMultiline, setIsDescriptionMultiline] = React.useState(true);

    return (
        <Stack spacing={8}>
            <FormField innerId='name' label='Name' noMargin={true}>
                <TextField
                    placeholder='Example: Invoice number'
                    value={props.name}
                    onChange={(val) => props.setName(val)}
                    focusOnMount={true}
                    // @ts-expect-error
                    autoFocus={false}
                    ignorePasswordAutoFill={true}
                />
            </FormField>
            <FormField innerId='entity' label='Entity' noMargin={true}>
                <div className={props.isEditing ? 'no-click disabled' : ''}>
                    <RadioGroup
                        name='entity'
                        inline={true}
                        spacing={8}
                        shouldSpaceHorizontally={true}
                        selectedValue={props.entityType}
                        onChange={props.setEntityType}
                    >
                        {ENTITY_TYPE_SELECT_OPTIONS.map((option: CustomFieldEntityOption) => {
                            const Icon = option.icon;

                            return (
                                <RadioIconButton
                                    // @ts-expect-error
                                    alignCenter={true}
                                    // @ts-expect-error
                                    icon={<Icon size={20} />}
                                    value={option.value}
                                    key={option.value}
                                >
                                    {option.label}
                                </RadioIconButton>
                            );
                        })}
                    </RadioGroup>
                </div>
            </FormField>
            <FormField innerId='fieldType' label='Field type' noMargin={true}>
                <div className={props.isEditing ? 'no-click disabled' : ''}>
                    <SelectTwoLine
                        name='custom-field-type'
                        isSearchable={false}
                        options={props.customFieldSelectOptions}
                        value={props.selectedCustomFieldOption}
                        onChange={(selectedFieldType: CustomFieldTypeOption) => {
                            setIsDescriptionMultiline(selectedFieldType.value !== 'ENUM');
                            props.setSelectedCustomFieldOption(selectedFieldType);
                        }}
                    />
                </div>
            </FormField>
            {props.selectedCustomFieldOption &&
                props.selectedCustomFieldOption.value === 'ENUM' && (
                    <FormField innerId='fieldDecisionChoices' noMargin={true}>
                        <CreateDecisionFieldChoices
                            choices={props.decisionFieldChoices}
                            onUpdateChoices={(choices: string[]) =>
                                props.setDecisionFieldChoices(choices)
                            }
                            hasAllowMultipleSelection={
                                props.canUpdateMultipleChoicesSetting
                                    ? {
                                          allowMultiple: Boolean(
                                              props.decisionFieldAllowMultiple &&
                                                  props.canUpdateMultipleChoicesSetting
                                          ),
                                          toggleAllowMultiple: () =>
                                              props.setDecisionFieldAllowMultiple(
                                                  !props.decisionFieldAllowMultiple
                                              ),
                                      }
                                    : undefined
                            }
                        />
                    </FormField>
                )}
            <FormField innerId='description' label='Description' noMargin={true}>
                <TextField
                    placeholder='Description of this field'
                    value={props.description}
                    onChange={(val) => props.setDescription(val)}
                    multiline={isDescriptionMultiline}
                />
            </FormField>
        </Stack>
    );
}
